import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { loginWithGoogle } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { IMAGES } from "@/lib/images";
import { Leaf } from "lucide-react";

export default function Login() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate("/portal", { replace: true });
  }, [user, navigate]);

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FAFAFA]">
      <div className="hidden lg:block relative">
        <img src={IMAGES.heroLandscape} alt="Landscape" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0E1F18]/90 to-[#0E1F18]/30" />
        <div className="absolute bottom-12 left-12 right-12">
          <h2 className="font-heading text-4xl font-semibold text-white">Your home & garden, mastered.</h2>
          <p className="mt-3 text-white/80 font-light">Manage bookings, save AI designs, and track your services — all in one place.</p>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-md text-center">
          <span className="flex h-14 w-14 items-center justify-center rounded-full bg-[#1A362D] text-white mx-auto">
            <Leaf className="h-7 w-7" />
          </span>
          <h1 className="mt-6 font-heading text-3xl sm:text-4xl font-semibold text-[#1A362D] tracking-tight">Welcome to Master Touch</h1>
          <p className="mt-3 text-[#4A5D4E] font-light">Sign in to book services and access your customer portal.</p>

          <Button
            onClick={() => loginWithGoogle("/portal")}
            data-testid="google-signin-btn"
            className="mt-8 w-full bg-white hover:bg-[#F2F4F2] text-[#1A362D] border border-[#E2E8E4] rounded-full py-6 text-base font-medium shadow-sm"
          >
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" className="h-5 w-5 mr-3" />
            Continue with Google
          </Button>

          <p className="mt-6 text-xs text-[#8A9A8C]">
            By continuing you agree to our Terms of Service and Privacy Policy.
          </p>
        </div>
      </div>
    </div>
  );
}
